var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lecture-remove"},[_vm._v(" 스크래치 Lecture Remove ")])}
var staticRenderFns = []

export { render, staticRenderFns }